import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * 전자결재 케밥(더보기) 드롭다운의 스타일.
 * 위치 지정(anchor/absolute root)은 호출부가 담당하고, 여기서는 박스/항목 스타일만 정의.
 */

/** `.action-menu-wrap` */
export const ActionMenuWrap = styled(Box)`
  position: relative;
  min-width: 160px;
  padding: 6px;
  border-radius: 8px;
  background-color: var(--dk-bg, #fff);
  border: 1px solid var(--dk-line, #e7e9ec);
  box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.08);
`;

/** `.action-menu-content` — 버튼 vertical stack */
export const ActionMenuContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ActionMenuItem = styled('button', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone?: 'default' | 'caution' }>(({ tone = 'default' }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '8px 12px',
  border: 'none',
  borderRadius: 6,
  background: 'transparent',
  color: tone === 'caution' ? '#f55060' : '#34383d',
  fontFamily: 'Pretendard, sans-serif',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '18px',
  textAlign: 'left',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background-color 120ms ease',

  '&:hover': {
    backgroundColor: 'var(--dk-bg-muted, #f3f5f6)',
  },
  '&:disabled': {
    color: 'var(--dk-text-dim, #c4c8cd)',
    cursor: 'not-allowed',
    backgroundColor: 'transparent',
  },
  '&:focus-visible': {
    outline: '2px solid #000',
    outlineOffset: -2,
  },
}));
